// OrderStatus.jsx
import { Button, Tooltip } from "antd";
import { Info, RefreshCw } from "react-feather";
import { useTranslation } from "react-i18next";

const OrderStatus = ({ record, onRefresh }) => {
  
  const { t } = useTranslation();

  const totalOrders = record.alibaba_orders_count ?? record.shipping_orders_count ?? 0;
  const arrivedCount = Math.min(
    record.arrived_orders_count ??
      record.alibaba_arrived_count ??
      0,
    totalOrders,
  );
  const canceledCount = Math.min(
    record.canceled_orders_count ??
      record.alibaba_canceled_count ??
      0,
    totalOrders,
  );
  const billNoCount = Math.min(
    record.alibaba_orders_with_bill_no ??
      record.alibaba_with_bill_no ??
      0,
    totalOrders,
  );
  const usedCircles = arrivedCount + canceledCount + billNoCount;
  const whiteCount = Math.max(0, totalOrders - usedCircles);

  const circles = [
    ...Array(arrivedCount).fill(<span className="green-circle" />),
    ...Array(canceledCount).fill(<span className="red-circle" />),
    ...Array(billNoCount).fill(<span className="yellow-circle" />),
    ...Array(whiteCount).fill(<span className="white-circle" />),
  ].slice(0, totalOrders);

  return (
    <div className="circle-container">
      <div>{circles}</div>
      <Button
        type="default"
        onClick={(e) => {
          const targetId = record.wege_order_id ?? record.id;
          if (!targetId) {
            e.stopPropagation();
            return;
          }
          onRefresh(targetId, e);
        }}
        disabled={!record.wege_order_id && !record.id}
      >
        <RefreshCw size={16} />
      </Button>
    </div>
  );
};

export const OrderStatusTitle = () => {
  const { t } = useTranslation();

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      {t("order.status.title")}
      <Tooltip
        title={
          <div>
            <div>
              <span className="green-circle" style={{ marginRight: "8px" }} />
              {t("order.status.arrived")}
            </div>
            <div>
              <span className="red-circle" style={{ marginRight: "8px" }} />
              {t("order.status.canceled")}
            </div>
            <div>
              <span className="yellow-circle" style={{ marginRight: "8px" }} />
              {t("order.status.processing")}
            </div>
            <div>
              <span className="white-circle" style={{ marginRight: "8px" }} />
              {t("order.status.pending")}
            </div>
          </div>
        }
      >
        <Info style={{ cursor: "pointer" }} size={16} />
      </Tooltip>
    </div>
  );
};

export default OrderStatus;
